import styled from "styled-components";

export const MoreChevronButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  cursor: pointer;
`;